import React from 'react';

const GreatServiceUI = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-6">
            Easy to find and <span className="text-cyan-400 font-semibold" style={{ color: 'rgba(65, 1, 150, 1)' }}>Great Service</span>
          </h1>
          <p className="text-gray-500 text-lg max-w-4xl mx-auto leading-relaxed">
            We are a competent team with extensive expertise and a strong commitment to providing
            excellent facility to you. We have high-quality Cabs available for your travel.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
          {/* Affordable prices */}
          <div className="flex flex-col items-center">
            <div className="w-72 h-96 border-4 border-gray-900 rounded-full bg-white flex flex-col items-center justify-center p-8 relative">
              <div className="mb-8">
                <svg viewBox="0 0 120 120" className="w-24 h-24">
                  {/* Money bags */}
                  <g>
                    {/* Back bag - green */}
                    <ellipse cx="70" cy="85" rx="22" ry="28" fill="#2D5F3F"/>
                    <path d="M 70 60 Q 75 55 70 50 Q 65 55 70 60" fill="#1F4430"/>
                    <text x="70" y="90" fontSize="24" fill="#FFD700" textAnchor="middle" fontWeight="bold">$</text>
                    
                    {/* Front bag - lighter green */}
                    <ellipse cx="50" cy="75" rx="24" ry="30" fill="#4A8B5F"/>
                    <path d="M 50 48 Q 55 43 50 38 Q 45 43 50 48" fill="#2D5F3F"/>
                    <text x="50" y="82" fontSize="26" fill="#FFD700" textAnchor="middle" fontWeight="bold">$</text>
                    
                    {/* Coins */}
                    <circle cx="85" cy="55" r="8" fill="#FFD700"/>
                    <circle cx="85" cy="55" r="6" fill="#FFC700"/>
                    
                    <circle cx="30" cy="50" r="6" fill="#FFD700"/>
                    <circle cx="30" cy="50" r="4" fill="#FFC700"/>
                    
                    <circle cx="40" cy="35" r="7" fill="#FFD700"/>
                    <circle cx="40" cy="35" r="5" fill="#FFC700"/>
                    
                    <circle cx="75" cy="35" r="5" fill="#FFD700"/>
                    <circle cx="75" cy="35" r="3" fill="#FFC700"/>
                  </g>
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">Affordable prices</h3>
              <p className="text-gray-500 text-center leading-relaxed">
                We work with the top Cab carriers to provide you the greatest deals
              </p>
            </div>
          </div>

          {/* Easy to Find */}
          <div className="flex flex-col items-center">
            <div className="w-72 h-96 border-4 border-gray-900 rounded-full bg-white flex flex-col items-center justify-center p-8">
              <div className="mb-8">
                <svg viewBox="0 0 120 120" className="w-24 h-24">
                  {/* Mobile phone */}
                  <rect x="35" y="20" width="50" height="80" rx="5" fill="#8B7BC8" stroke="#6B5BA8" strokeWidth="2"/>
                  <rect x="40" y="28" width="40" height="60" rx="2" fill="#F5F5F5"/>
                  
                  {/* Screen content - checkmark */}
                  <circle cx="60" cy="50" r="12" fill="#22C55E" opacity="0.2"/>
                  <path d="M 52 50 L 58 56 L 70 42" stroke="#22C55E" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                  
                  {/* Text lines on screen */}
                  <line x1="45" y1="65" x2="65" y2="65" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round"/>
                  <line x1="45" y1="72" x2="75" y2="72" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round"/>
                  
                  {/* Home button */}
                  <circle cx="60" cy="92" r="3" fill="#6B5BA8"/>
                  
                  {/* Paper/document beside */}
                  <rect x="75" y="45" width="25" height="35" rx="2" fill="#E5E7EB" stroke="#9CA3AF" strokeWidth="1.5"/>
                  <line x1="80" y1="52" x2="95" y2="52" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/>
                  <line x1="80" y1="58" x2="95" y2="58" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/>
                  <line x1="80" y1="64" x2="90" y2="64" stroke="#9CA3AF" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">Easy to Find</h3>
              <p className="text-gray-500 text-center leading-relaxed">
                We at Shree Puja Travels Want to make seat reservations as simple as possible for you.
              </p>
            </div>
          </div>

          {/* Easy Book */}
          <div className="flex flex-col items-center">
            <div className="w-72 h-96 border-4 border-gray-900 rounded-full bg-white flex flex-col items-center justify-center p-8">
              <div className="mb-8">
                <svg viewBox="0 0 120 120" className="w-24 h-24">
                  {/* Isometric seat */}
                  <defs>
                    <linearGradient id="seatGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#EF4444" />
                      <stop offset="100%" stopColor="#DC2626" />
                    </linearGradient>
                  </defs>
                  
                  {/* Shadow */}
                  <ellipse cx="60" cy="90" rx="30" ry="8" fill="#000" opacity="0.1"/>
                  
                  {/* Seat base - isometric view */}
                  <path d="M 40 70 L 60 60 L 80 70 L 60 80 Z" fill="url(#seatGrad)"/>
                  <path d="M 60 60 L 80 70 L 80 75 L 60 85 Z" fill="#DC2626"/>
                  <path d="M 40 70 L 60 80 L 60 85 L 40 75 Z" fill="#B91C1C"/>
                  
                  {/* Seat back */}
                  <path d="M 42 50 L 62 40 L 78 48 L 78 68 L 58 78 L 42 70 Z" fill="#FCD34D"/>
                  <path d="M 62 40 L 78 48 L 78 68 L 62 60 Z" fill="#FBBF24"/>
                  <path d="M 42 50 L 62 40 L 62 60 L 42 70 Z" fill="#F59E0B"/>
                  
                  {/* Armrests */}
                  <path d="M 38 65 L 42 63 L 42 55 L 38 57 Z" fill="#9CA3AF"/>
                  <path d="M 78 55 L 82 57 L 82 65 L 78 63 Z" fill="#6B7280"/>
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">Easy Book</h3>
              <p className="text-gray-500 text-center leading-relaxed">
              We make cab booking effortless, with honest fares and zero hidden fees.        
              </p>
            </div>
          </div>

          {/* Ticket Booking Option */}
          <div className="flex flex-col items-center">
            <div className="w-72 h-96 border-4 border-gray-900 rounded-full bg-white flex flex-col items-center justify-center p-8">
              <div className="mb-8">
                <svg viewBox="0 0 120 120" className="w-24 h-24">
                  {/* Ticket */}
                  <defs>
                    <linearGradient id="ticketGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#A78BFA" />
                      <stop offset="100%" stopColor="#8B5CF6" />
                    </linearGradient>
                  </defs>
                  
                  {/* Main ticket body */}
                  <rect x="30" y="40" width="60" height="45" rx="4" fill="url(#ticketGrad)"/>
                  
                  {/* Ticket notches */}
                  <circle cx="30" cy="62.5" r="4" fill="#F3F4F6"/>
                  <circle cx="90" cy="62.5" r="4" fill="#F3F4F6"/>
                  
                  {/* Dashed line */}
                  <line x1="35" y1="62.5" x2="85" y2="62.5" stroke="#DDD6FE" strokeWidth="1.5" strokeDasharray="3,3"/>
                  
                  {/* Star on ticket */}
                  <path d="M 60 50 L 62 56 L 68 56 L 63 60 L 65 66 L 60 62 L 55 66 L 57 60 L 52 56 L 58 56 Z" fill="#FCD34D"/>
                  
                  {/* Text lines */}
                  <rect x="35" y="70" width="20" height="3" rx="1.5" fill="#DDD6FE"/>
                  <rect x="35" y="76" width="25" height="3" rx="1.5" fill="#DDD6FE"/>
                  
                  {/* Barcode area */}
                  <rect x="60" y="68" width="2" height="12" fill="#DDD6FE"/>
                  <rect x="64" y="68" width="3" height="12" fill="#DDD6FE"/>
                  <rect x="69" y="68" width="2" height="12" fill="#DDD6FE"/>
                  <rect x="73" y="68" width="3" height="12" fill="#DDD6FE"/>
                  <rect x="78" y="68" width="2" height="12" fill="#DDD6FE"/>
                  <rect x="82" y="68" width="3" height="12" fill="#DDD6FE"/>
                </svg>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4 text-center">Cab Booking Option</h3>
              <p className="text-gray-500 text-center leading-relaxed">
Book your cab easily with several convenient options.

              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GreatServiceUI;